/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-empty-function */
import FederatedMFE from 'common/components/FederatedMFE';
import { injectReducerAsync } from 'app/reduxStore';
import { useSelector } from 'react-redux';
import { ProjectListLayout } from 'common/components/layouts';
import featureFlags, {
  isDisplayFormatEnabled,
  isSVGminitableIngestionEnabled,
  isInlineCommentingEnabled,
} from 'common/helpers/featureFlags';
import {
  getFakeClientUser,
  getUserRole,
  getIsThirdPartyMember,
} from 'common/redux/security/loggedInUser/loggedInUserSlice';
import styles from './ProjectsPage.module.scss';
import { getProject } from '../../project/projectSlice';

const ProjectsPage: React.FC = () => {
  const { navigation, ImageIngestionEnabled } = useSelector(getProject);
  const userRole = useSelector(getUserRole);
  const isFakeClientUser = useSelector(getFakeClientUser);
  const isThirdPartyMember = useSelector(getIsThirdPartyMember);

  return (
    <div className={styles.container}>
      <ProjectListLayout>
        <FederatedMFE
          urlKey="REACT_APP_PROJECT_TOPIC_MFE_URL"
          scope="project"
          reducerModule="./ProjectReducers"
          componentModule="./ProjectRoute"
          injectionReducerCb={injectReducerAsync}
          props={{
            enableImageUpload:
              featureFlags.isImageUploadEnabled &&
              ImageIngestionEnabled === 'true',
            platformName: process.env.REACT_APP_PLATFORM_NAME,
            commentingControllerUrl:
              process.env.REACT_APP_COMMENTING_CONTROLLER_MFE_URL,
            commentingSidebarUrl:
              process.env.REACT_APP_COMMENTING_SIDEBAR_MFE_URL,
            countUrl: process.env.REACT_APP_NOTIFICATIONS_COUNTS_MFE_URL,
            countLinkUrl:
              process.env.REACT_APP_NOTIFICATIONS_COUNT_LINK_MFE_URL,
            rteLibraryEndpoint:
              process.env.REACT_APP_RICH_TEXT_LIBRARY_ITEM_SERVICE,
            pptLibraryEndpoint: process.env.REACT_APP_PPT_LIBRARY_ITEM_SERVICE,
            excelLibraryEndpoint:
              process.env.REACT_APP_EXCEL_LIBRARY_ITEM_SERVICE,
            powerBiLibraryEndpoint:
              process.env.REACT_APP_POWERBI_LIBRARY_ITEM_SERVICE,
            tableauEndpoint: process.env.REACT_APP_TABLEAU_API,
            apiBaseUrl: process.env.REACT_APP_PO_TOPIC_SERVICE,
            engagementUrl: process.env.REACT_APP_ENGAGEEMENT_URL,
            engagementId: process.env.REACT_APP_ENGAGEEMENT_ID,
            dpReportUrl: process.env.REACT_APP_DP_REPORT_URL,
            clipboardUrl: process.env.REACT_APP_CLIPBOARD_LIBRARY_ITEM_SERVICE,
            projectEndpoint: process.env.REACT_APP_PROJECT_API_BASE_PATH,
            structuredAnalysisEndpoint:
              process.env.REACT_APP_STRUCTURED_ANALYSIS_SERVICE,
            featureFlags: {
              isLiveLinkingEnabled: featureFlags.isLiveLinkingEnabled,
              isAutoSaveEnabled: featureFlags.isAutoSaveEnabled,
              isInlineCommentingEnabled,
              isP3Enabled: featureFlags.isP3Enabled,
              isDisabledCountApi: featureFlags.isDisabledCountApi,
              isDisplayFormatEnabled,
              isSVGminitableIngestionEnabled,
              isInlineCommentEnabled: isInlineCommentingEnabled,
              isPowerBiIngestionEnabled: featureFlags.isPowerBiIngestionEnabled,
              isVersioningEnabled: featureFlags.isVersioningPhase1Enabled,
              isLiveReportPreviewEnabled: featureFlags.isPOTopicRefactorEnabled,
              isImageUploadEnabled: featureFlags.isImageUploadEnabled,
              isSVGScalingEnabled: featureFlags.isSVGScalingEnabled,
              isLRPLoaderFlagEnabled: featureFlags?.isLRPLoaderFlagEnabled,
            },
            autoSaveConfig: {
              lockDelay: Number(process.env.REACT_APP_AUTO_LOCK_DELAY),
              saveDelay: Number(process.env.REACT_APP_AUTO_SAVE_DELAY),
              idleTimeThreshold: Number(
                process.env.REACT_APP_AUTO_SAVE_IDLE_TIME
              ),
              isDev: featureFlags.isAutoSaveDevMode,
              apiBaseUrl: process.env.REACT_APP_PO_TOPIC_SERVICE,
              apiBaseUrlLock: process.env.REACT_APP_LOCK_API_BASE_PATH,
            },
            richTextConfig: {
              licenseKey: process.env.REACT_APP_CK_EDITOR_LICENSE as string,
              uploadUrl: process.env.REACT_APP_IMAGE_API as string,
            },
            versioningUrl: process.env.REACT_APP_VERSIONING_MFE_URL as string,
            liveReportPreviewUrl: process.env
              .REACT_APP_LIVE_REPORT_PREVIEW_MFE_URL as string,
            commentingIdleTimeout: Number(
              process.env.REACT_APP_COMMENTING_IDLE_TIMEOUT as string
            ),
            navigation,
            userRole,
            isFakeClientUser,
            isThirdPartyMember,
          }}
        />
      </ProjectListLayout>
    </div>
  );
};

export default ProjectsPage;
